import $ from 'jquery';

(function () {
  const overlayClass = 'energy-insights__overlay';
  let active = null;

  function getOverlay() {
    let overlay = document.querySelector(`.${overlayClass}`);

    if (!overlay) {
      overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.className = overlayClass;
      overlay.setAttribute('aria-label', 'Close energy insight');
      document.body.appendChild(overlay);
    }

    return overlay;
  }

  function getCardColumns(grid) {
    return Array.prototype.slice.call(
      grid.querySelectorAll('[data-energy-insight-card-col]')
    ).filter((column) => {
      return column.parentNode === grid && column.offsetParent !== null;
    });
  }

  function moveDetailAfterSelectedRow(grid, selectedColumn, detail) {
    const selectedTop = selectedColumn.offsetTop;
    const rowColumns = getCardColumns(grid).filter((column) => {
      return Math.abs(column.offsetTop - selectedTop) < 8;
    });
    const lastColumn = rowColumns[rowColumns.length - 1] || selectedColumn;

    lastColumn.insertAdjacentElement('afterend', detail);
  }

  function setTriggerLabel(trigger, label) {
    if (!trigger || !label) {
      return;
    }

    trigger.textContent = label;
  }

  function scrollCardToTop(selectedColumn) {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';
    const top = selectedColumn.getBoundingClientRect().top + window.pageYOffset;

    window.requestAnimationFrame(() => {
      window.scrollTo({
        top,
        behavior
      });
    });
  }

  function openDetail(trigger) {
    const id = trigger.getAttribute('data-energy-insight-trigger');
    const grid = trigger.closest('.energy-insights__cards');
    const selectedColumn = trigger.closest('[data-energy-insight-card-col]');
    const card = trigger.closest('.energy-insights__card');
    const detail = grid ? grid.querySelector(`[data-energy-insight-detail="${id}"]`) : null;

    if (!grid || !selectedColumn || !card || !detail) {
      return;
    }

    if (active && active.id === id) {
      closeDetail();
      return;
    }

    closeDetail(false);
    moveDetailAfterSelectedRow(grid, selectedColumn, detail);

    const overlay = getOverlay();
    overlay.classList.add('is-active');
    overlay.addEventListener('click', closeDetail);

    detail.hidden = false;
    detail.style.height = '0px';
    detail.classList.add('is-open');
    card.classList.add('is-selected');
    trigger.setAttribute('aria-expanded', 'true');

    const triggerLabel = trigger.textContent.trim();
    setTriggerLabel(trigger, 'Close');

    active = {
      id,
      card,
      detail,
      grid,
      selectedColumn,
      trigger,
      triggerLabel,
      overlay
    };

    scrollCardToTop(selectedColumn);

    window.requestAnimationFrame(() => {
      detail.style.height = `${detail.scrollHeight}px`;
    });

    window.setTimeout(() => {
      if (active && active.detail === detail) {
        detail.style.height = 'auto';
      }
    }, 360);
  }

  function closeDetail(animate = true) {
    if (!active) {
      return;
    }

    const { card, detail, trigger, triggerLabel, overlay } = active;
    active = null;

    card.classList.remove('is-selected');
    trigger.setAttribute('aria-expanded', 'false');
    setTriggerLabel(trigger, triggerLabel);
    overlay.classList.remove('is-active');
    overlay.removeEventListener('click', closeDetail);

    const finish = () => {
      detail.hidden = true;
      detail.classList.remove('is-open');
      detail.style.height = '';
      detail.removeEventListener('transitionend', finish);
    };

    if (!animate) {
      finish();
      return;
    }

    detail.style.height = `${detail.scrollHeight}px`;

    window.requestAnimationFrame(() => {
      detail.style.height = '0px';
    });

    detail.addEventListener('transitionend', finish);
  }

  function repositionActiveDetail() {
    if (!active) {
      return;
    }

    moveDetailAfterSelectedRow(active.grid, active.selectedColumn, active.detail);
  }

  function copyUrl(button) {
    const url = button.getAttribute('data-copy-url');
    const label = button.querySelector('[data-energy-insight-copy-label]');
    const originalLabel = label ? label.textContent : '';

    if (!url) {
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url);
    } else {
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }

    button.classList.add('is-copied');

    if (label) {
      label.textContent = 'Copied';
    }

    window.setTimeout(() => {
      button.classList.remove('is-copied');

      if (label) {
        label.textContent = originalLabel || 'Copy url';
      }
    }, 1600);
  }

  function showCategoryLoading(select) {
    const page = select.closest('.energy-insights-page');
    const cards = page ? page.querySelector('.energy-insights__cards') : null;
    const url = select.value;

    if (!cards || !url || url === window.location.href.split('#')[0]) {
      return;
    }

    cards.classList.add('is-loading');
  }

  function openHashInsight() {
    const hash = window.location.hash || '';

    if (hash.indexOf('#energy-insight-') !== 0) {
      return;
    }

    const id = hash.replace('#energy-insight-', '');
    const trigger = document.querySelector(`[data-energy-insight-trigger="${id}"]`);

    if (!trigger) {
      return;
    }

    window.setTimeout(() => {
      trigger.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      window.setTimeout(() => openDetail(trigger), 350);
    }, 200);
  }

  $(document).on('click', '[data-energy-insight-trigger]', function () {
    openDetail(this);
  });

  $(document).on('click', '[data-energy-insight-close]', function () {
    closeDetail();
  });

  $(document).on('click', '[data-energy-insight-copy-url]', function () {
    copyUrl(this);
  });

  $(document).on('change', '.energy-insights-page .newsroom-filter-select', function () {
    showCategoryLoading(this);
  });

  $(document).on('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDetail();
    }
  });

  $(window).on('resize', repositionActiveDetail);
  $(window).on('hashchange', openHashInsight);

  $(openHashInsight);
})();
